import { ChangeDetectionStrategy, Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { UnimportedItemGroup } from 'src/app/common/models/unimportedItemGroup';
import { AuthManager } from 'src/app/core/auth/auth.manager';

import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-unimported-item-group-tile',
  templateUrl: './unimported-item-group-tile.component.html',
  styleUrl: './unimported-item-group-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatButton, MatIcon],
})
export class UnimportedItemGroupTileComponent implements OnInit {
  @Input() public viewModel!: UnimportedItemGroup;
  @Output() public externalItemNumberImportEmit: EventEmitter<void> = new EventEmitter<void>();

  public isExternalItemNumberGroup!: boolean;
  public authManager: AuthManager;

  constructor(private auth: AuthManager) {
    this.authManager = this.auth;
  }

  public ngOnInit(): void {
    this.isExternalItemNumberGroup = this.viewModel.isExternalItemNumberGroup;
  }

  public commodityImport(): void {
    this.externalItemNumberImportEmit.emit();
  }
}
